// frontend/src/components/SearchBar/SearchBar.tsx
import React from 'react';
import './SearchBar.css';

export interface SearchBarProps {
  placeholder?: string;
  value?: string;
  onChange?: (newVal: string) => void;
  onMenuClick?: () => void;
  onSearch?: () => void;
}

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Kennitala',
  value = '',
  onChange,
  onMenuClick,
  onSearch,
}) => {
  const handleSearchClick = () => {
    onSearch?.();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch?.();
    }
  };

  return (
    <div className="search-container">
      {/* <div className="menu-icon" onClick={onMenuClick}>
        ☰
      </div> */}

      <input
        className="search-input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <div className="search-icon" onClick={handleSearchClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="search-svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default SearchBar;

// // frontend/src/components/SearchBar/SearchBar.tsx
// import React from 'react';
// import './SearchBar.css';

// export interface SearchBarProps {
//   placeholder?: string;
//   value?: string;
//   onChange?: (newVal: string) => void;
//   onMenuClick?: () => void;
//   onSearch?: () => void;
// }

// const SearchBar: React.FC<SearchBarProps> = ({
//   placeholder = 'Kennitala',
//   value,
//   onChange,
//   onMenuClick,
//   onSearch,
// }) => (
//   <div className="search-container">
//     <div className="menu-icon" onClick={onMenuClick}>
//       ☰
//     </div>
//     <input
//       className="search-input"
//       type="text"
//       placeholder={placeholder}
//       value={value}
//       onChange={(e) => onChange?.(e.target.value)}
//     />
//     <div className="search-icon" onClick={onSearch}>
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         fill="none"
//         viewBox="0 0 24 24"
//         strokeWidth="1.5"
//         stroke="currentColor"
//         className="size-6"
//       >
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
//         />
//       </svg>
//     </div>
//   </div>
// );

// export default SearchBar;
